export type ModalPreset =
  | 's'
  | 'l'
  | 'small'
  | 'medium'
  | 'large'
  | 'feedback'
  | 'feedbackWithoutCrossSell'
  | 'eresaModal'
  | 'eresaModalResults'
  | 'paymentError'
  | 'sizeGuide'
  | 'nameValidationWarning';

export type ModalPresetNew =
  | 'small'
  | 'medium'
  | 'large'
  | 'mobileSmall'
  | 'mobileFull'
  | 'inheritWidth';

export enum Devices {
  mobile,
  tablet,
  desktop,
}

export enum WS_EVENTS {
  VERSION_UPDATE = 'VERSION_UPDATE',
  MAINTENANCE_SWITCH = 'MAINTENANCE_SWITCH',
}

export enum StatsigFlags {
  MAP_BOX = 'map-box',
  JOIN_VIDEO = 'join-video',
}
